<template>
  <el-row>
    <el-col :span="11" style="padding-bottom: 4rem">
      <basic-container>
        <h2 style="text-align: center">按钮操作配置</h2>
        <avue-crud
          :option="option"
          :table-loading="loading"
          :data="data"
          :page="page"
          :permission="permissionList"
          :before-open="beforeOpen"
          v-model="form"
          ref="crud"
          @row-update="rowUpdate"
          @row-save="rowSave"
          @row-del="rowDel"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="onLoad"
          @on-load="onLoad"
        >
          <template slot="userIdsForm">
            <el-input
              readonly
              v-model="form.userIds"
              style="display: none"
            ></el-input>
            <el-input
              readonly
              @focus="addUserBox"
              v-model="formUserNames"
            ></el-input>
          </template>
          <template slot="menuLeft">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              v-if="permission.ordersettingaction_delete"
              @click="handleDelete"
              >删 除
            </el-button>
          </template>
        </avue-crud>
      </basic-container>
    </el-col>
    <el-col :span="11" offset="1" style="padding-bottom: 4rem">
      <basic-container>
        <h2 style="text-align: center">备注模板管理</h2>
        <avue-crud
          :option="option2"
          :table-loading="loading"
          :data="data2"
          :page="page2"
          :permission="permissionList2"
          :before-open="beforeOpen2"
          v-model="form2"
          ref="crud2"
          @row-update="rowUpdate2"
          @row-save="rowSave2"
          @row-del="rowDel2"
          @search-change="searchChange2"
          @search-reset="searchReset2"
          @selection-change="selectionChange2"
          @current-change="currentChange2"
          @size-change="sizeChange2"
          @refresh-change="onLoad2"
          @on-load="onLoad2"
        >
          <template slot-scope="scope" slot="menu">
            <el-button
              type="text"
              size="small"
              v-if="permissionList.moveBtn"
              icon="el-icon-top"
              @click.native="upData(scope.row)"
              >上移
            </el-button>
            <el-button
              type="text"
              size="small"
              v-if="permissionList.moveBtn"
              icon="el-icon-bottom"
              @click.native="downData(scope.row)"
              >下移
            </el-button>
          </template>
        </avue-crud>
      </basic-container>
    </el-col>

    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :projectId="tempProjectId"
      />
    </el-dialog>
  </el-row>
</template>
<script>
import {
  addAction,
  getActionDetail,
  getActionList,
  removeAction,
  updateAction,
  availableActionList,
  getTemplateList,
  getTemplateDetail,
  removeTemplate,
  addTemplate,
  updateTemplate,
  upTemplate,
  downTemplate,
} from "@/api/v4ward/gateservice/ordersetting/setting/ordersettingextra";
import { mapGetters } from "vuex";
import userEditBox from "@/views/crmedical/group/user-edit-box";
import { getUserListByDepartmentId } from "@/api/crmedical/group/group";

export default {
  props: ["flowid", "projectId"],
  components: {
    userEditBox,
  },
  data() {
    return {
      formUserNames: "",
      handleAction: "",
      selectUserType: "",
      tempProjectId: "",
      dialogUserEditBoxVisible: false,
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        columnBtn: false,
        refreshBtn: false,
        indexLabel: "序号",
        align: "center",
        dialogWidth: 800,
        column: [
          {
            label: "工单状态",
            prop: "workStatus",
            editDisabled: true,
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=out_order_work_status",
            search: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
            rules: [
              {
                required: true,
                message: "请选择工单状态",
                trigger: "change",
              },
            ],
          },
          {
            label: "工单操作",
            prop: "actionType1",
            type: "select",
            dicUrl: "/api/blade-system/dict/dictionary?code=order_action",
            search: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            hide: true,
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
          },
          {
            label: "工单操作",
            prop: "actionTypeName",
            addDisplay: false,
            viewDisplay: false,
            editDisplay: false,
          },
          {
            label: "工单操作",
            prop: "actionType",
            type: "select",
            hide: true,
            dicData: [],
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择工单操作",
                trigger: "change",
              },
            ],
          },
          {
            label: "审批设置",
            prop: "approveType",
            type: "select",
            dataType: "number",
            dicUrl: "/api/blade-system/dict/dictionary?code=order_approve_type",
            search: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择审批设置",
                trigger: "change",
              },
            ],
          },
          {
            label: "审批人员",
            prop: "userIds",
            formslot: true,
            hide: true,
          },
          {
            label: "排序",
            prop: "sortNo",
            type: "number",
            placeholder: "输入数字，序号小的靠前",
            rules: [
              {
                required: true,
                message: "请输入备注",
                trigger: "change",
              },
            ],
          },
          {
            label: "描述",
            prop: "description",
            overHidden: true,
            placeholder: "50字以内",
            maxlength: 50,
          },
        ],
      },
      data: [],
      ///////////////////////////////////////////////////////////////////////
      form2: {},
      query2: {},
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList2: [],
      option2: {
        height: "auto",
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: false,
        selection: false,
        dialogClickModal: false,
        indexLabel: "序号",
        columnBtn: false,
        column: [
          {
            label: "内容",
            prop: "remark",
            type: "textarea",
            span: 24,
            minRow: 2,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: "请输入备注",
                trigger: "change",
              },
            ],
          },
        ],
      },
      data2: [],
    };
  },
  watch: {
    "form.workStatus"(val) {
      console.log("form.workStatus==>", val);
      this.initActionTypeList();
    },
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.ordersettingaction_add, true),
        viewBtn: this.vaildData(this.permission.ordersettingaction_view, false),
        delBtn: this.vaildData(this.permission.ordersettingaction_delete, true),
        editBtn: this.vaildData(this.permission.ordersettingaction_edit, true),
        moveBtn: this.vaildData(this.permission.ordersettingaction_move, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
    ids2() {
      let ids = [];
      this.selectionList2.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    handleSubmitAction(val) {
      console.log(val);
      this.formUserNames = val.nameListString;
      this.form.userIds = val.idListString;
      this.dialogUserEditBoxVisible = false;
    },
    handleCloseAction(val) {
      this.dialogUserEditBoxVisible = false;
    },
    addUserBox() {
      this.tempProjectId = this.projectId;

      this.handleAction = 1;
      this.selectUserType = 1;

      this.dialogUserEditBoxVisible = true;
    },
    initActionTypeList() {
      let workStatus = this.form.workStatus;
      if (this.vdui.isNotEmpty(workStatus)) {
        availableActionList({ workStatus: workStatus }).then((res) => {
          var actionTypeColumn = this.findObject(
            this.option.column,
            "actionType"
          );
          actionTypeColumn.dicData = res.data;
          // this.form.actionType = '';
          if (res.data.length === 0) {
            actionTypeColumn.dicData = [{}];
            this.$message.warning("当前工单状态下没有可操作的动作！");
          }
        });
      }
    },
    rowSave(row, done, loading) {
      row.settingId = this.flowid;
      addAction(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      updateAction(row).then(
        () => {
          this.onLoad();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeAction({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeAction({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getActionDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;

          getUserListByDepartmentId({}).then((res) => {
            // console.log(res.data);
            // console.log(res);
            let idList = [];
            let nameList = [];
            let nameListString = "";
            res.data.forEach((ele) => {
              idList.push(ele.id);
              nameList.push(ele.realName);
            });
            if (idList.length > 0) {
              idListString = idList.join(",");
              nameListString = nameList.join(",");
            }
            // this.OrderSettingFlowForm.timeoutNotifyIds = idListString
            this.formUserNames = nameListString;
            console.log("nameListString=========>",nameListString);
            console.log(this.timeoutUserNames);
          });
        });
      }
      if (["add"].includes(type)) {
        this.formUserNames = "";
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      if (this.vdui.isEmpty(this.flowid)) {
        console.log("flowid为空！");
        return;
      }
      this.query.settingId = this.flowid;
      page = page || this.page;
      this.loading = true;
      getActionList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
    ////////////////////////////////////////////////////////////////////////
    rowSave2(row, done, loading) {
      row.settingId = this.flowid;
      addTemplate(row).then(
        () => {
          this.onLoad2();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate2(row, index, done, loading) {
      updateTemplate(row).then(
        () => {
          this.onLoad2();
          this.$message.success("操作成功!");
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel2(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeTemplate({ ids: row.id });
        })
        .then(() => {
          this.onLoad2();
          this.$message.success("操作成功!");
        });
    },
    handleDelete2() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeTemplate({ ids: this.ids2 });
        })
        .then(() => {
          this.onLoad2();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen2(done, type) {
      if (["edit", "view"].includes(type)) {
        getTemplateDetail({ id: this.form2.id }).then(({ data }) => {
          this.form2 = data;
        });
      }
      done();
    },
    searchReset2() {
      this.query2 = {};
      this.onLoad();
    },
    searchChange2(params, done) {
      this.query2 = params;
      this.page2.currentPage = 1;
      this.onLoad2();
      done();
    },
    selectionChange2(list) {
      this.selectionList2 = list;
    },
    selectionClear2() {
      this.selectionList2 = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange2(currentPage) {
      this.page2.currentPage = currentPage;
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },
    onLoad2(page) {
      page = page || this.page2;
      this.loading = true;
      this.query2.settingId = this.flowid;
      getTemplateList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query2
        )
      ).then(({ data }) => {
        this.page2.total = data.total;
        this.data2 = data;
        this.loading = false;
        this.selectionClear2();
      });
    },
    upData(row) {
      upTemplate(row).then((res) => {
        console.log(res);
        this.onLoad2();
      });
    },
    downData(row) {
      downTemplate(row).then((res) => {
        console.log(res);
        this.onLoad2();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
 max-height: calc(100% - 1px);
   max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
